import { QuantitySelectorComponent } from '@theme/component-quantity-selector';

/**
 * A custom element that allows the user to select a quantity in the cart.
 * Extends QuantitySelectorComponent but uses absolute max limits instead of effective max.
 * Semantics: "What should the total quantity BE in the cart" vs "How many to ADD to cart"
 *
 * @extends {QuantitySelectorComponent}
 */
class CartQuantitySelectorComponent extends QuantitySelectorComponent {
  /**
   * Gets the effective maximum value for cart quantity selector
   * Cart page: uses absolute max (how much can be in cart total)
   * @returns {number | null} The effective max, or null if no max
   */
  getEffectiveMax() {
    const { max } = this.getCurrentValues();
    return max; // Cart uses absolute max, not max minus cart quantity
  }

  /**
   * Updates button states based on current value and limits
   * Cart buttons are always managed client-side, never server-disabled
   */
  updateButtonStates() {
    const { minusButton, plusButton } = this.refs;
    const { value } = this.getCurrentValues();
    const effectiveMax = this.getEffectiveMax();

    // Cart buttons are always dynamically managed
    minusButton.disabled = value <= 0;
    plusButton.disabled = effectiveMax !== null && value >= effectiveMax;
  }

  /**
   * Lets the cart minus button remove the line when the current quantity is at the minimum.
   * @param {Event} event - The click event.
   */
  decreaseQuantity(event) {
    if (!(event.target instanceof HTMLElement)) return;
    event.preventDefault();

    const { quantityInput } = this.refs;
    const { min, value } = this.getCurrentValues();

    if (value <= min) {
      if (!quantityInput.dataset.cartLine) {
        const row = this.closest('.cart-items__table-row');
        const rows = row?.parentElement?.querySelectorAll('.cart-items__table-row');
        const line = row && rows ? Array.from(rows).indexOf(row) + 1 : 0;

        if (line > 0) {
          quantityInput.dataset.cartLine = line.toString();
        }
      }

      quantityInput.value = '0';
      this.onQuantityChange();
      this.updateButtonStates();
      return;
    }

    this.updateQuantity(-1);
  }
}

if (!customElements.get('cart-quantity-selector-component')) {
  customElements.define('cart-quantity-selector-component', CartQuantitySelectorComponent);
}
